const translations = {
    connectionError: 'Connection Error',
    enrichFailed: 'Failed to load product details'
};

export default translations;
